import React from 'react'
import { FormattedMessage } from 'react-intl'
import PersonName from 'components/PersonName'

export const TwoPersonList = ({ person1, person2 }) => (
  <span>
    <PersonName person={person1} />
    <FormattedMessage id="activity.name_and" />
    <PersonName person={person2} />
  </span>
)

export const AllPeopleList = ({ people }) => (
  <span>
    {people
      .slice(0, people.length - 1)
      .map(
        (p, idx) =>
          p && [
            <PersonName key={p.username} person={p} />,
            <FormattedMessage key={`comma_${idx}`} id="activity.name_comma" />
          ]
      )}
    <FormattedMessage id="activity.name_and" />
    <PersonName person={people[people.length - 1]} />
  </span>
)

export const SomePeopleList = ({ people, showCount }) => (
  <span>
    {people
      .slice(0, showCount)
      .map(
        (p, idx) =>
          p && [
            <PersonName key={p.username} person={p} />,
            <FormattedMessage key={`comma_${idx}`} id="activity.name_comma" />
          ]
      )}
    <FormattedMessage
      id="activity.and_n_others"
      values={{ n: people.length - showCount }}
    />
  </span>
)

const AbbreviatedPersonList = ({ people, showCount }) => {
  if (people.length > showCount) {
    if (showCount > 0) {
      return <SomePeopleList people={people} showCount={showCount} />
    } else {
      return (
        <FormattedMessage
          id="activity.n_people"
          values={{ n: people.length }}
        />
      )
    }
  } else {
    switch (people.length) {
      case 1:
        return <PersonName person={people[0]} />
      case 2:
        return <TwoPersonList person1={people[0]} person2={people[1]} />
      default:
        return <AllPeopleList people={people} />
    }
  }
}

export default AbbreviatedPersonList
